<div class="eventCounter" *ngIf="false">
  <div class="container">
    <!-- <h5>PAST EVENT</h5> -->
    <h2>UniBuild's Event Coming Soon</h2>
    <!-- <h4>11th December, 2024</h4> -->
    <p>Bringing Together Global Industry Leaders to address Supply Chain Challenges, Uncover Solutions, and Drive
      Innovation. </p>
    <div class="counterWrapp" *ngIf="timeLeft">
      <div class="countItem">
        <h4>{{ timeLeft?.days}}</h4>
        <span>Days</span>
      </div>
      <div class="countItem">
        <h4>{{ timeLeft?.hours}}</h4>
        <span>Hours</span>
      </div>
      <div class="countItem">
        <h4>{{timeLeft?.minutes}}</h4>
        <span>Minutes</span>
      </div>
      <div class="countItem">
        <h4>{{timeLeft?.seconds}}</h4>
        <span>Seconds</span>
      </div>
    </div>
  </div>
</div>
<section>
  <div class="container">
    <div class="typeEvent">
      <!-- <span class="active">Past Events</span> -->
      <!-- <button>Past Events</button> -->
    </div>
    <div class="row">
      <div class="col-md-4 col-12" *ngFor="let event of eventsList">
        <div class="eventWarap" [style.background-image]="'url(' + event.image + ')'">
          <!-- <img src="{{event.image}}" /> -->
          <div class="eventCaption">
            <div class="textdec">
              <span class="dateItem" *ngIf="!event.expire">{{event.date}}</span>
              <h3 title="{{event.name}}">{{event.name}}</h3>
              <div class="venue"><lucide-icon name="map-pin" color="#fff" class="icon" size="16"></lucide-icon>
                {{event.venue}}</div>
              <p class="link" *ngIf="event.hyperlink && event.hyperlink.includes('youtube.com')">
                <lucide-icon name="play" color="#fff" class="icon" size="16"></lucide-icon> <a [href]="event.hyperlink"
                  target="_blank">Watch here</a>
              </p>
              <p class="linkedin-link" *ngIf="event.hyperlink && event.hyperlink.includes('lnkd.in')">
                <lucide-icon name="link" color="#fff" class="icon" size="16"></lucide-icon> <a [href]="event.hyperlink"
                  target="_blank">LinkedIn</a>
              </p>
              <p class="desc" *ngIf="!event.hyperlink.includes('youtube.com')" title="{{event.description}}">
                {{event.description}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<section class=" upcomingDetail" *ngIf="false">
  <div class="container">
    <div class="row">
      <div class="col-md-5">
        <div class="detailTest">
          <h4>Schedule of event</h4>
          <h2>List of Events Planned in this Conference</h2>
          <p>Bringing Together Global Industry Leaders to address Supply Chain Challenges, Uncover
            Solutions, and Drive
            Innovation.</p>
          <!-- <button class="primaryButton">Download Schedule</button> -->
        </div>
      </div>
      <div class="col-md-6 ml-auto">
        <div class="detailGraph">
          <div class="item">
            <img src="../../../../assets/images/dtl1.jpg" alt="">
            <img src="../../../../assets/images/dtl3.jpg" alt="">
          </div>
          <div class="item">
            <div class="info">
              <h3>December 11, 2024
                <span>1:30-5:00 PM IST</span>
              </h3>
              <p>Bringing Together Global Industry Leaders to address Supply Chain Challenges, Uncover
                Solutions, and
                Drive Innovation.</p>
            </div>
            <img src="../../../../assets/images/dtl2.jpg" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="grayBox speaker" *ngIf="false">
  <div class="container">
    <div class="secTitle">
      <h2>Event Speaker</h2>
      <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam orci nulla, facilisis sit amet eros non, eleifend
        rhoncus nibh. Donec posuere luctus sem at gravida. Nam sollicitudin</p>
    </div>
    <div class="row">
      <div class="col-md-3 col-6" *ngFor="let speaker of speakerList">
        <div class="speakerWrapp">
          <div class="speakerImg">
            <img src="{{speaker.image}}" alt="" />
            <div class="speakerHover">
              <div class="linkItem" (click)="viewSpeakerDetail(speaker.id)">
                <lucide-icon name="eye" color="#fff" class="icon" size="18"></lucide-icon>
                <p>more details</p>
              </div>
            </div>
          </div>
          <div class="speakerCaption">
            <h3>{{speaker.name}}</h3>
            <p>{{speaker.department}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>

</section>